export default "__VITE_ASSET__DFeLV4KT__"